import TransportistasForm from "./TransportistasForm";
export default TransportistasForm;